"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m12.61 5.335-4.77 7.15h3.454c.835 0 1.379.806 1.176 1.562l-1.227 4.565 4.93-8.066h-3.49c-.853 0-1.397-.836-1.165-1.6zm1.062-2.203c.479.242.821.815.623 1.47L12.92 9.147h3.56c.997 0 1.518 1.1 1.036 1.888l-5.733 9.378a1.194 1.194 0 0 1-1.537.475 1.226 1.226 0 0 1-.674-1.452l1.492-5.55H7.519c-1.02 0-1.533-1.144-1.009-1.93l5.61-8.409a1.194 1.194 0 0 1 1.552-.413",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TriggerIcon24.js.map